module.exports = __webpack_public_path__ + "media/file_icons/excel-1b624a7a.png";